.g6{z-index:2;}